import { FC } from "react";
import "styles/legend-item.scss";
import "styles/tooltip.scss";
import { LegendItemProps } from "types/atoms.types";

const LegendItem: FC<LegendItemProps> = ({ icon, label, name }) => {
  return (
    <div className="asr-legend__item">
      <img src={icon} alt={label} />
      <span>{label}</span>
    </div>
  );
};

export default LegendItem;
